module.exports = __webpack_public_path__ + "static/media/0010_LES_MURS_POSE_VERTICALE.e817e7be.webp";